import { render } from "./WarningsJournalTable.vue?vue&type=template&id=72050ca8&scoped=true"
import script from "./WarningsJournalTable.vue?vue&type=script&lang=js"
export * from "./WarningsJournalTable.vue?vue&type=script&lang=js"

import "./WarningsJournalTable.vue?vue&type=style&index=0&id=72050ca8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72050ca8"]])

export default __exports__